export default class ViewIntegerVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	name = "Integer";
	defaultValue = 0;
	fieldType = 'integer';
	uiComponent = 'view-integer-field';
	description = 'Whole number.';

	constructor()
	{
		
	}
}